/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, convertHexToRGB } from 'utils/styles/style_helpers';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// IMAGE SELECTOR : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	imagetypes: {
        display: 'flex',
        justifyContent: 'space-evenly',
        marginBottom: pxToEm(12),
        // actual nav item
        '& .imagetype': {
            backgroundColor: 'transparent',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: '50%',
            borderRadius: pxToEm(16),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            color: `rgba(6, 43, 117, 0.5)`,
            fontSize: pxToEm(16),
            textAlign: 'center',
            height: pxToEm(32),
            padding: replacePXinStringWithEM(`0 12px`),
            transition: theme.animation.general('all'),
            '&:hover': {
                '&:not(.selectedTab)': {
                    backgroundColor: theme.color.secondary.xlight.swatch
                },
            },
            '&.selectedTab': {
                backgroundColor: convertHexToRGB(theme.color.primary.medium.swatch, 10),
                color: theme.color.primary.medium.swatch,
                '&.unsplash': {
                    backgroundImage: `url(${url.image.app}/logo-unsplash-blue.png)`,
                },
                '&.shutterstock': {
                    backgroundImage: `url(${url.image.app}/logo-shutterstock-blue.png)`,
                }
            },
            '&.unsplash, &.shutterstock': {
                width: pxToEm(130),
                '& span': { display: 'none' }
            },
            '&.unsplash': {
                backgroundSize: '53%',
                backgroundImage: `url(${url.image.app}/logo-unsplash-grey.png)`
            },
            '&.shutterstock': {
                backgroundSize: '58%',
                backgroundImage: `url(${url.image.app}/logo-shutterstock-grey.png)`
            }
        }
	}
});